/**
 * Contenu éditorial de la page /bapteme (baptême & communion).
 * Texte fourni par le client (fichier 05) — variables renseignées par le client.
 */

export const BAPTEME_CONTENT = {
  fr: {
    meta: {
      title: "Repas de baptême & communion à Ville-d'Avray",
      description:
        "Déjeuner de baptême ou de communion dans un hôtel particulier à Ville-d'Avray (92) : espace privatisé dès 12 convives, terrasse de 240 m², menu maison sur-mesure.",
      keywords:
        "repas de baptême Ville d'Avray, communion 92, déjeuner de famille Hauts-de-Seine, salle baptême privatisée",
    },
    breadcrumb: [
      { label: "Accueil", to: "/" },
      { label: "Événements", to: "/evenements" },
      { label: "Baptême & communion" },
    ],
    overline: "Baptême & communion · Ville-d'Avray (92)",
    h1: "Repas de baptême et de communion à Ville-d'Avray",
    intro:
      "Après la cérémonie, réunissez votre famille autour d'une vraie table, dans un hôtel particulier entouré de verdure. L'Entracte vous réserve un espace privatisé, une salle ou la terrasse de 240 m², et compose avec vous un menu entièrement fait maison, pour les grands comme pour les petits.",
    ctaDevis: "Demander un devis baptême",
    ctaCall: "Appeler le 01 82 00 18 67",
    heroAlt: "Déjeuner de baptême en famille à L'Entracte, Ville-d'Avray",

    brief: {
      title: "Votre baptême en bref",
      caption: "Informations clés pour un repas de baptême à L'Entracte",
      rows: [
        ["Lieu", "Hôtel particulier, 3 rue de Versailles, 92410 Ville-d'Avray"],
        ["Capacité", "De 12 à 100 convives"],
        ["Espaces", "Une salle privatisée, la terrasse de 240 m² ou tout l'établissement"],
        ["Budget indicatif", "Déjeuner assis dès 50 € HT par personne"],
        ["Durée", "3 heures incluses, heures supplémentaires 400 € de l'heure"],
        ["Parking", "Stationnement à proximité immédiate du restaurant"],
      ],
    },

    family: {
      title: "Le déjeuner de famille, notre spécialité",
      body:
        "Un baptême ou une communion se célèbre le plus souvent un dimanche midi, et c'est justement un service où L'Entracte est ouvert. Selon le nombre de convives, nous vous réservons une salle, la terrasse ou l'établissement entier. Vous accueillez vos proches dans un cadre élégant, sans avoir à gérer le repas ni le service.",
      alt: "Apéritif de communion sur la terrasse de L'Entracte",
    },

    timeline: {
      title: "Le déroulé type",
      steps: [
        {
          label: "L'apéritif :",
          body: "vos invités arrivent de la cérémonie et sont accueillis autour d'un apéritif, en terrasse aux beaux jours.",
        },
        {
          label: "Le déjeuner :",
          body: "entrée, plat et dessert, composés avec le chef selon la saison et vos goûts.",
        },
        {
          label: "Le gâteau et le café :",
          body: "le moment de réunir tout le monde pour les photos. Le chef peut réaliser votre dessert de fête, et vous pouvez aussi apporter votre propre gâteau (conditions précisées dans le devis).",
        },
      ],
    },

    menu: {
      title: "Un menu pensé pour toute la famille",
      body:
        "Notre cuisine traditionnelle et créative est élaborée exclusivement à partir de produits frais, entièrement faite maison. Le chef construit avec vous un menu adapté à votre famille ; les options végétariennes et les régimes spécifiques sont possibles sur demande. Un menu enfant (plat et dessert) est proposé à 40 €.",
      ctaMenu: "Voir la carte",
    },

    why: {
      title: "Pourquoi choisir L'Entracte pour un baptême ?",
      items: [
        { label: "Un espace rien que pour vous", body: ", dès 12 convives." },
        { label: "Une terrasse de 240 m² sur parc", body: " pour l'apéritif et les photos de famille." },
        { label: "Une cuisine 100 % maison", body: " plutôt qu'un traiteur." },
        { label: "Un repli à l'intérieur", body: " si la météo n'est pas de la partie." },
        { label: "Un accès simple", body: " depuis Versailles, Sèvres, Chaville, Saint-Cloud et Paris." },
      ],
    },

    access: {
      title: "Accès",
      intro:
        "L'Entracte se trouve au 3 rue de Versailles, 92410 Ville-d'Avray : 15 minutes de Versailles, 15 minutes de Paris.",
      note:
        "Gare de Sèvres – Ville-d'Avray à 1 km, desservie par la ligne L (depuis Paris Saint-Lazare et La Défense) et la ligne U (depuis La Défense). Parking : stationnement à proximité immédiate du restaurant.",
    },

    faqTitle: "Questions fréquentes",
    faq: [
      {
        question: "À partir de combien de personnes peut-on privatiser un espace ?",
        answer:
          "Dès 12 convives. Au-delà, nous privatisons la terrasse, une seconde salle ou l'établissement entier, jusqu'à 100 invités assis.",
      },
      {
        question: "Quel budget prévoir pour un repas de baptême ?",
        answer:
          "Déjeuner assis dès 50 € HT par personne, selon le menu choisi et le nombre de convives. Chaque devis est établi sur-mesure.",
      },
      {
        question: "Y a-t-il un menu enfant ?",
        answer: "Oui, un menu enfant (plat et dessert) est proposé à 40 €.",
      },
      {
        question: "Peut-on apporter notre propre gâteau ?",
        answer:
          "Le chef peut réaliser votre dessert de fête, et vous pouvez aussi apporter votre propre gâteau (conditions précisées dans le devis).",
      },
      {
        question: "Peut-on organiser le repas un dimanche midi ?",
        answer:
          "Oui, c'est même le moment le plus demandé. Pensez à réserver tôt, car les dimanches de printemps partent vite.",
      },
      {
        question: "Le lieu est-il accessible avec une poussette ou un fauteuil roulant ?",
        answer: "Oui, nos espaces sont accessibles aux personnes à mobilité réduite et aux poussettes.",
      },
      {
        question: "Combien de temps à l'avance faut-il réserver ?",
        answer: "Comptez environ 2 mois à l'avance.",
      },
    ],

    devis: {
      title: "Organisons ensemble votre baptême",
      body: "Indiquez-nous la date, le nombre d'adultes et d'enfants : nous revenons vers vous avec une proposition.",
      contact: "Téléphone : 01 82 00 18 67 · E-mail : restaurantlentractevda@gmail.com",
    },

    related: {
      title: "Autres événements",
      links: [
        { to: "/evenements", label: "Toutes nos réceptions privées" },
        { to: "/galerie", label: "La galerie photos" },
        { to: "/anniversaire", label: "Anniversaire et fête de famille" },
      ],
    },

    eventType: "Baptême / communion",
  },

  en: {
    meta: {
      title: "Christening & communion meals in Ville-d'Avray",
      description:
        "Christening or communion lunch in a private townhouse in Ville-d'Avray (92): private space from 12 guests, a 240 m² terrace, bespoke house-made menu.",
      keywords:
        "christening meal Ville d'Avray, communion 92, family lunch Hauts-de-Seine, private christening room",
    },
    breadcrumb: [
      { label: "Home", to: "/" },
      { label: "Events", to: "/evenements" },
      { label: "Christening & communion" },
    ],
    overline: "Christening & communion · Ville-d'Avray (92)",
    h1: "Christening and communion meals in Ville-d'Avray",
    intro:
      "After the ceremony, gather your family around a real table, in a private townhouse surrounded by greenery. L'Entracte reserves a private space for you — a lounge or the 240 m² terrace — and creates a menu with you that is made entirely in-house, for grown-ups and children alike.",
    ctaDevis: "Request a christening quote",
    ctaCall: "Call +33 1 82 00 18 67",
    heroAlt: "Family christening lunch at L'Entracte, Ville-d'Avray",

    brief: {
      title: "Your christening at a glance",
      caption: "Key information for a christening meal at L'Entracte",
      rows: [
        ["Venue", "Private townhouse, 3 rue de Versailles, 92410 Ville-d'Avray"],
        ["Capacity", "12 to 100 guests"],
        ["Spaces", "A private lounge, the 240 m² terrace or the entire venue"],
        ["Indicative budget", "Seated lunch from €50 excl. VAT per person"],
        ["Duration", "3 hours included, additional hours €400 per hour"],
        ["Parking", "In the immediate vicinity of the restaurant"],
      ],
    },

    family: {
      title: "The family lunch, our speciality",
      body:
        "A christening or a communion is most often celebrated on a Sunday lunchtime — precisely a service when L'Entracte is open. Depending on the number of guests, we reserve a lounge, the terrace or the entire venue for you. You welcome your loved ones in an elegant setting, without having to manage the meal or the service.",
      alt: "Communion aperitif on the terrace of L'Entracte",
    },

    timeline: {
      title: "A typical schedule",
      steps: [
        {
          label: "The aperitif:",
          body: "your guests arrive from the ceremony and are welcomed with an aperitif, on the terrace in fine weather.",
        },
        {
          label: "The lunch:",
          body: "starter, main course and dessert, created with the chef according to the season and your tastes.",
        },
        {
          label: "The cake and coffee:",
          body: "the moment to gather everyone for photos. The chef can create your celebration dessert, and you may also bring your own cake (conditions set out in the quote).",
        },
      ],
    },

    menu: {
      title: "A menu designed for the whole family",
      body:
        "Our traditional and creative cuisine is made exclusively from fresh produce, entirely in-house. The chef builds a menu with you to suit your family; vegetarian options and special diets are available on request. A children's menu (main course and dessert) is offered at €40.",
      ctaMenu: "See the menu",
    },

    why: {
      title: "Why choose L'Entracte for a christening?",
      items: [
        { label: "A space just for you", body: ", from 12 guests." },
        { label: "A 240 m² terrace overlooking the park", body: " for the aperitif and family photos." },
        { label: "100% house-made cuisine", body: " rather than a caterer." },
        { label: "An indoor fallback", body: " if the weather does not cooperate." },
        { label: "Easy access", body: " from Versailles, Sèvres, Chaville, Saint-Cloud and Paris." },
      ],
    },

    access: {
      title: "Getting here",
      intro:
        "L'Entracte is at 3 rue de Versailles, 92410 Ville-d'Avray: 15 minutes from Versailles, 15 minutes from Paris.",
      note:
        "Sèvres – Ville-d'Avray station 1 km away, served by line L (from Paris Saint-Lazare and La Défense) and line U (from La Défense). Parking: in the immediate vicinity of the restaurant.",
    },

    faqTitle: "Frequently asked questions",
    faq: [
      {
        question: "From how many people can a space be hired privately?",
        answer:
          "From 12 guests. Beyond that, we hire out the terrace, a second lounge or the entire venue, for up to 100 seated guests.",
      },
      {
        question: "What budget should we plan for a christening meal?",
        answer:
          "Seated lunch from €50 excl. VAT per person, depending on the menu chosen and the number of guests. Every quote is bespoke.",
      },
      {
        question: "Is there a children's menu?",
        answer: "Yes, a children's menu (main course and dessert) is offered at €40.",
      },
      {
        question: "Can we bring our own cake?",
        answer:
          "The chef can create your celebration dessert, and you may also bring your own cake (conditions set out in the quote).",
      },
      {
        question: "Can the meal be held on a Sunday lunchtime?",
        answer:
          "Yes, and it is the most requested slot. Book early, as spring Sundays go quickly.",
      },
      {
        question: "Is the venue accessible with a pram or a wheelchair?",
        answer: "Yes, our spaces are accessible to guests with reduced mobility and to prams.",
      },
      {
        question: "How far in advance should we book?",
        answer: "Allow around 2 months in advance.",
      },
    ],

    devis: {
      title: "Let's plan your christening together",
      body: "Tell us the date and the number of adults and children: we will get back to you with a proposal.",
      contact: "Phone: +33 1 82 00 18 67 · Email: restaurantlentractevda@gmail.com",
    },

    related: {
      title: "Other events",
      links: [
        { to: "/evenements", label: "All our private receptions" },
        { to: "/galerie", label: "The photo gallery" },
        { to: "/anniversaire", label: "Birthdays and family celebrations" },
      ],
    },

    eventType: "Christening / communion",
  },
};
